import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { viewBtachBO } from './viewbatch.model';

@Injectable({
  providedIn: 'root'
})

export class ViewbatchService extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient, public errorService: ErrorService) {
    super();
  }

  public execute(state: viewBtachBO): void {
    this.getViewBatch(state).subscribe(x => super.next(x));
  }

  getViewBatch(state?: viewBtachBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Claims/getEDI837List", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }

  getpowerbiToken(): Observable<any> {
    let url = "api/PowerBI/GetAccessToken?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }
}
